import { useRef } from 'react';
import times from 'lodash/times';

export const useScrollIntoView = (numberOfElements: number = 1) => {
  const errorTagRefs = times(numberOfElements, () => useRef<HTMLDivElement>(null));

  const scrollToError = (index: number = 0) => {
    if (errorTagRefs[index]?.current) {
      errorTagRefs[index]?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  };

  return { errorTagRefs, scrollToError };
};
